import {post} from './http';
import {
	GenericHttpError,
	throwIncorrectUsernameOrPasswordError,
	throwFailedToAuthenticateError,
	throwSessionTimedOutError,
} from '../errors';

export default {

	authenticate(request) {
		return post(`${__API_URL__}/account/authenticate`, request, null)
			.catch(error => {
				if (error instanceof GenericHttpError && error.status === 401) {
					throwIncorrectUsernameOrPasswordError();
				} else {
					throwFailedToAuthenticateError(error);
				}
			});
	},

	renewAuthentication(authorizationToken) {
		return post(`${__API_URL__}/account/renewAuthentication`, {}, authorizationToken)
			.catch(error => {
				throwSessionTimedOutError();
			});
	},

} as UserApi;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/api/user.ts